export default function getGrid(timebar) {
    var gridRow = timebar.find(function (row) { return !!row.useAsGrid; });
    var gridCells = (gridRow === null || gridRow === void 0 ? void 0 : gridRow.cells) || [];
    return gridCells;
}
